import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpErrorResponse, HttpParams } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { protectedResources } from '../auth-config';
import { environment } from 'src/environments/environment';
import { ToastService } from './toast.service';
import { IntegrationRunTime } from '../models/integration-runtime';
import { DataResponse } from '../models/data-response';

@Injectable()
export class IntegrationRunTimeService {
    private baseUrl: string = protectedResources.LOSTalkerAPI.endpoint;
    private actionUrl = '';
    private Url = '';
    private headers = new HttpHeaders();

    private errorHandler(error: HttpErrorResponse, ts: ToastService): Observable<any> {
      ts.toastCreate('An HTTP transport error occured: ' + error.url + ' ' + error.status, 'Warning', {
        keepAfterRouteChange: true,
      });

      if (environment.enableDebuggingTools) {
        console.error('An HTTP transport error occured: ' + error.error);
      }

      return throwError(() => error);
    }

    constructor(private http: HttpClient, private toastService: ToastService) { }

    // GET
    getAllIntegrationRunTimes(): Observable<IntegrationRunTime[]> {
      this.actionUrl = 'IntegrationRunTimes/';
      this.Url = this.baseUrl.concat(this.actionUrl);
      return this.http
        .get<IntegrationRunTime[]>(this.Url)
        .pipe(catchError(err => this.errorHandler(err, this.toastService)));
    }

    // GET
    // getRunTime(integrationId: string, typeId: string): Observable<RunTime> {
    //     this.actionUrl = "RunTime/GetRunTime/";
    //     this.Url = this.baseUrl.concat(this.actionUrl);
    //     return this.http.get<RunTime>(this.Url)
    //     .pipe(catchError(this.handleError));
    // }

    // GET
    getAllIntegrationRunTimesByIntegration(integrationId: string): Observable<IntegrationRunTime[]> {
        this.actionUrl = 'IntegrationRunTimes/';
        this.Url = this.baseUrl.concat(this.actionUrl, integrationId);
        return this.http.get<IntegrationRunTime[]>(this.Url)
        .pipe(catchError(err => this.errorHandler(err, this.toastService)));
    }

    // GET ALL BY LIST
    getAllIntegrationRunTimesByIntegrationList(integrationIds: string[]): Observable<IntegrationRunTime[]> {
        this.actionUrl = 'IntegrationRunTimes/List';
        this.Url = this.baseUrl.concat(this.actionUrl);

        var params = new HttpParams({
          fromObject: {'iIdList': integrationIds},
        });
        return this.http.get<IntegrationRunTime[]>(this.Url, { params })
        .pipe(catchError(err => this.errorHandler(err, this.toastService)));
    }

    // POST
    addIntegrationRunTime(integrationRunTime: IntegrationRunTime): Observable<string> {
        this.actionUrl = 'IntegrationRunTime/';
        this.Url = this.baseUrl.concat(this.actionUrl);
        this.headers.append('Content-Type', 'application/json');
        return this.http
            .post(this.Url, integrationRunTime, { headers: this.headers })
            .pipe(catchError(err => this.errorHandler(err, this.toastService)));
    }

    // POST
    addIntegrationRunTimes(integrationRunTimes: IntegrationRunTime[]): Observable<IntegrationRunTime[]> {
      this.actionUrl = 'IntegrationRunTimes/';
      this.Url = this.baseUrl.concat(this.actionUrl);
      this.headers.append('Content-Type', 'application/json');
      return this.http
          .post<IntegrationRunTime[]>(this.Url, integrationRunTimes, { headers: this.headers })
          .pipe(catchError(err => this.errorHandler(err, this.toastService)));
  }

    // PUT
    updateIntegrationRunTime(integrationRunTime: IntegrationRunTime): Observable<IntegrationRunTime> {
        this.actionUrl = 'IntegrationRunTime/';
        this.Url = this.baseUrl.concat(this.actionUrl);
        this.headers.append('Content-Type', 'application/json');
        return this.http
            .put<IntegrationRunTime>(this.Url, integrationRunTime, { headers: this.headers })
            .pipe(catchError(err => this.errorHandler(err, this.toastService)));
    }

    // DELETE
    deleteIntegrationRunTime(integrationRunTimeId: string): Observable<IntegrationRunTime> {
        this.actionUrl = 'IntegrationRunTime/';
        this.Url = this.baseUrl.concat(this.actionUrl, integrationRunTimeId);
        // console.log(this.Url);
        return this.http
            .delete<IntegrationRunTime>(this.Url)
            .pipe(catchError(err => this.errorHandler(err, this.toastService)));
    }

    // PUT
    updateBulkIntegrationRunTimes(integrationIds: string[], i: number[], d: number[], l?: Date, n?: Date): Observable<any> {
      const data = new DataResponse(integrationIds, false, '', '', l, n, d, i);
      this.actionUrl = 'IntegrationRunTimes/update';
      this.Url = this.baseUrl.concat(this.actionUrl);
      this.headers.append('Content-Type', 'application/json');

      return this.http
          .put<any>(this.Url, data, { headers: this.headers })
          .pipe(catchError(err => this.errorHandler(err, this.toastService)));
  }
}
